import * as React from 'react'
import { useLocation, useNavigate } from 'react-router-dom'

import { Box, Touchable } from '@factorialco/deprecated-design-system'

import { useNavigation } from 'modules/core/hooks/useNavigation'
import i18n from 'modules/core/lib/i18n'

import WidgetHeader from 'modules/attendance/components/ClockIn/Shifts/HourlyShifts/HourlyCounterWithTimeCategories/WidgetHeader'
import MinutesToText from 'modules/attendance/components/MinutesToText'
import { OvertimePoolsCollection } from 'modules/attendance/hooks/OvertimePoolsCollection'
import { useAttendanceDateNavigator } from 'modules/attendance/lib/attendanceDateNavigatorContext'
import { TimeBlocksBalanceCollection } from 'modules/attendance/store/models/TimeBlocksBalanceCollection'

import Bar from './Bar'

interface Props {
  overtimePools: OvertimePoolsCollection
  timeBlocksBalance: TimeBlocksBalanceCollection
  employeeId: number
  range?: string
}

export const BalanceBreakdown = ({
  overtimePools,
  timeBlocksBalance,
  employeeId,
  range,
}: Props) => {
  const { navigation } = useNavigation()
  const navigate = useNavigate()
  const { pathParams } = useAttendanceDateNavigator()
  const location = useLocation()

  const params = {
    ...pathParams,
    employeeId,
  }

  const balanceBreakdownSidepanelUrl = location.pathname.includes(navigation.clockIn.path)
    ? navigation.clockIn.periodTypeYearMonthDay.balanceBreakdownEmployeeId.fullPath(params)
    : navigation.timeTracking.employee.periodTypeYearMonthDayEmployeeId.balanceBreakdownEmployeeId.fullPath(
        params
      )

  const balancePoolMinutes = timeBlocksBalance.balancePoolMinutes
  const balancePoolCapacity = overtimePools.getBalancePoolCapacity()

  return (
    <Touchable onClick={() => navigate(balanceBreakdownSidepanelUrl)}>
      <Box justifyContent="center" paddingX="s24" gap="s8">
        <Box justifyContent="flexStart" width="s240" gap="s16">
          <WidgetHeader title={i18n.t('clock_in.balance_header.title')} range={range} />
          <Bar balancePoolMinutes={balancePoolMinutes} balancePoolCapacity={balancePoolCapacity} />
        </Box>
        <Box alignSelf="flexEnd">
          <MinutesToText
            value={balancePoolMinutes}
            size="400"
            weight="medium"
            color="grey1000"
            withPlusSign
          />
        </Box>
      </Box>
    </Touchable>
  )
}
